/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.branding.rpc.BrandingColorRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const listByPortalIdRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'listByPortalId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAB0whlk1ni_JZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listByBrandKitIdRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'listByBrandKitId',
  auth: 'app',
  fingerprint: 'ZSworqXNwC_WR3mnrNxpA5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'zF0bfbyANXkBXK4XW-t2cJuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'zlNroilLRJcBXK4XW-t2cJuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: '274el8sG5jSOUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchCreateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'batchCreate',
  auth: 'app',
  fingerprint: '5E4la33v58MC1LaW7GqyKZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchUpdateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'batchUpdate',
  auth: 'app',
  fingerprint: 'Dj1AOmYjjXBYCs8fsToTvpuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchDeleteRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingColorRpc',
  rpcName: 'batchDelete',
  auth: 'app',
  fingerprint: 'IQjxeMMCnWOOUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};